import type { TOriginSize } from '@vlabs/monokit/shared/ui/canvas';

import { REGEX } from './constants';
import type { TRectangle } from '../../types';

export const normalizeAbsValue = (
  rawValue: string,
  field: keyof TRectangle,
  region: TRectangle,
  bbox: TRectangle,
): number => {
  let value = rawValue;
  const {
    x, y, width, height,
  } = region;

  const normalizationMap = {
    x: (v: number) => {
      if (v + width > bbox.width) return bbox.width - width;
      return Math.max(v, 0);
    },
    y: (v: number) => {
      if (v + height > bbox.height) return bbox.height - height;
      return Math.max(v, 0);
    },
    width: (v: number) => {
      if (v + x > bbox.width) return bbox.width - x;
      return Math.max(v, 1);
    },
    height: (v: number) => {
      if (v + y > bbox.height) return bbox.height - y;
      return Math.max(v, 1);
    },
  };

  if (!REGEX.allNumbers.test(value)) value = value.replace(/\D/g, '');

  return normalizationMap[field](Number(value));
};

export const normalizePercentValue = (
  rawValue: string,
  field: keyof TRectangle,
  region: TRectangle,
  bbox: TRectangle,
  mediaSize: TOriginSize,
): number => {
  let value: number | string = rawValue;
  const {
    x, y, width, height,
  } = region;

  const normalizationMap = {
    x: (v: number) => {
      const validatedValue = v + width > bbox.width
        ? bbox.width - width
        : Math.max(v, 0);
      return (validatedValue / 100) * mediaSize.width;
    },
    y: (v: number) => {
      const validatedValue = v + height > bbox.height
        ? bbox.height - height
        : Math.max(v, 0);
      return (validatedValue / 100) * mediaSize.height;
    },
    width: (v: number) => {
      const validatedValue = v + x > bbox.width
        ? bbox.width - x
        : Math.max(v, 0.01);
      return (validatedValue / 100) * mediaSize.width;
    },
    height: (v: number) => {
      const validatedValue = v + y > bbox.height
        ? bbox.height - y
        : Math.max(v, 0.01);
      return (validatedValue / 100) * mediaSize.height;
    },
  };

  // Определяем количество знаков после запятой, чтобы отрезать 2 знака без округления
  let decimalPlaces: number | undefined = 0;
  if (value.includes('.')) decimalPlaces = value.split('.')[1]?.length;
  value = decimalPlaces && decimalPlaces > 2 ? (Math.trunc(+value * 100) / 100) : value;

  return normalizationMap[field](Number(value));
};
